export const USER_AUTH_GET = "user/get";
export const USER_AUTH_DELETE = "user/delete";
